<template src="./ModalProductImportComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, computed} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {AppConstant} from "@/supports/app.constant";
import {useProductStore} from "@/stores/product.js";
import {useAccountStore} from "@/stores/account.js";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import {useSettingFormatFileStore} from "@/stores/settingFormatFile.js";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import InputImportComponent from "@/components/inputs/input-import/InputImportComponent.vue";
import ErrorMessageService from "@/services/error-message.service.ts";
import {useWarehouseStore} from "@/stores/warehouse.js";
export default {
  name: 'ModalProductImportComponent',
  components: {
    InputImportComponent,
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModalProduct: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    listProductsSelected: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['showModalProduct', 'errorMessage'],
  setup(props, { emit }) {
    const errors = ref(true)
    const dataModal = ref({
      file: {
        id: 'file',
        label: 'File',
        placeholder: 'Chọn File',
        value: null,
        required: false,
        disable: false,
        error: '',
        isError: false,
      },
      table_use: {
        id: 'table_use',
        label: 'Nơi sử dụng',
        placeholder: 'Nơi sử dụng',
        value: '',
        required: false,
        disable: true,
      },
      name: {
        id: 'name',
        label: 'Tên cài đặt',
        placeholder: 'Tên cài đặt',
        value: '',
        required: false,
        disable: false,
        options: []
      },
      type: {
        id: 'type',
        label: 'Kiểu File',
        placeholder: 'Kiểu File',
        value: '',
        required: false,
        disable: true,
      },
      warehouse_id: {
        id: 'warehouse_id',
        label: 'Kho hàng',
        placeholder: 'Kho hàng',
        value: '',
        required: true,
        disable: false,
        options: []
      },
    })
    const clickShowModal = ref(false)
    const accountStore = useAccountStore()
    const settingFormatFileStore = useSettingFormatFileStore()
    const warehouseStore = useWarehouseStore()

    // bind event click show modal to call api get list product
    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      clickShowModal.value = eventClickShowModal
      dataModal.value.table_use.value = 'Sản phẩm'
      if(clickShowModal.value) {
        getListFormatFile();
        getListWarehouses();
      }
      emit('showModalProduct', true)
    })

    watch(() => settingFormatFileStore.settingFormat, (newListSettingFormat) => {
      dataModal.value.name.options = []
      newListSettingFormat.forEach((item) => {
        dataModal.value.name.options.push({
          name: item.name,
          value: item.id,
        })
      })
    });

    watch(() => dataModal.value.name.value, (newSetting) => {
      const settingSelected = settingFormatFileStore.settingFormat.find(setting => newSetting === setting.id)
      dataModal.value.type.value = CommonService.compareTypeFileLabel(settingSelected.type ?? 0)
      validateFileSelected()
    });

    function onChange(value, name) {
      dataModal.value[name].value = value;
    }

    async function getListFormatFile() {
      const params = {
        company_id: accountStore.account.company.id,
        table_use: 'product',
      }
      const url = AppConstant.URL_API_LOCAL + 'api/format-file/format-list';
      await settingFormatFileStore.getListFormatFileWithoutLimit(url, params);
    }

    async function getListWarehouses() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/list-warehouse';
      await warehouseStore.getListWarehouses(url, params);
      warehouseStore.warehouses.forEach((warehouse) => {
        dataModal.value.warehouse_id.options.push({
          name: warehouse.name,
          value: warehouse.id
        })
      })
    }

    async function importFile() {
      for (const item in dataModal.value) {
        validateForm(dataModal.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const formData = new FormData();
        formData.append('file_upload', dataModal.value.file.value);
        formData.append('company_id', accountStore.account.company.id);
        formData.append('setting_format_id', dataModal.value.name.value);
        formData.append('setting_other', JSON.stringify({'warehouse_id': dataModal.value.warehouse_id.value}));

        const url = AppConstant.URL_API_LOCAL + 'api/format-file/import';
        const res = await settingFormatFileStore.importFile(url, formData);
        const errorMessage = await ErrorMessageService.getErrorMessage(res)
        if((typeof errorMessage === 'string' && errorMessage) || (typeof errorMessage === 'array' && errorMessage.length > 0)) {
          emit('errorMessage', errorMessage)
        }else {
          await CommonService.showAlertPopup({
            title: 'Nhập file hàng loạt sản phẩm hoàn tất.',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
            width: '800px'
          });
        }

        emit('showModalProduct', false)
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function validateForm(value, name) {
      if(name === 'file') {
        validateFileSelected()
      }
    }

    function actionFileSelected(file) {
      const target = file.target;
      if (target && target.files) {
        dataModal.value.file.value = target.files[0];
        dataModal.value.file.placeholder = target.files[0].name.length > 22 ? (target.files[0].name.substring(0, 20) + '...') : target.files[0].name
      }

      validateFileSelected()
    }

    function validateFileSelected() {
      errors.value = false
      dataModal.value.file.isError = false;
      dataModal.value.file.error = ''
      if(!dataModal.value.file.value) {
        dataModal.value.file.isError = true;
        errors.value = true
        dataModal.value.file.error = ErrorText.REQUIRED(dataModal.value.file.label);
      }

      const extFile = dataModal.value.file.value?.name.split('.')
      if(dataModal.value.file.value) {
        if(!['xlsx', 'xls', 'csv'].includes(extFile[extFile.length - 1])) {
          dataModal.value.file.isError = true;
          errors.value = true
          dataModal.value.file.error = ErrorMessageConstant.ERROR_FILE_EXT_INVALID;
        }

        if(dataModal.value.type.value && extFile[extFile.length - 1] !== dataModal.value.type.value) {
          dataModal.value.file.isError = true;
          errors.value = true
          dataModal.value.file.error = ErrorMessageConstant.ERROR_FILE_IMPORT_NOT_TO_THE_SAME_SETTING;
        }
      }
    }

    return {
      dataModal,
      onChange,
      importFile,
      actionFileSelected,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modalProductImport {
  .modal-lg {
    max-width: 75rem
  }
  .modal-content {
    background: #ffffff;
  }

  .modal-body {
    .select-form, .input-number {
      width: 180px;
    }
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
